module.exports = __webpack_public_path__ + "static/makkara_3-4c30416f41a4c777b9c718ae58a7e35a.jpg";